import { render } from "@wordpress/element";
import { Block } from "./block";

window.addEventListener("DOMContentLoaded", () => {
	const selector = ".wp-block-steam-blocks-knowledge-base";
	const root = document.querySelector(selector);

	if (root) {
		render(<Block />, root);
	} else {
		console.warn("Steam Blocks: Knowledge base block root not found.");
	}
});
